// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kds-order-timing {
  --timing-ink: #344254;
  --timing-border: #a8b2bd;
  --timing-surface: #f1f4f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid var(--timing-border);
  border-left-width: 4px;
  border-radius: 10px;
  background: var(--timing-surface);
  color: var(--timing-ink);
  font: inherit;
}

.kds-order-card .kds-order-timing {
  margin: 10px 0 6px;
}

.kds-pending-card .kds-order-timing {
  margin-top: 12px;
}

.kds-order-card.kds-timing--green,
.kds-order-card.kds-timing--orange,
.kds-order-card.kds-timing--red,
.kds-pending-card.kds-timing--green,
.kds-pending-card.kds-timing--orange,
.kds-pending-card.kds-timing--red {
  background-image: none !important;
  border-left-width: 4px !important;
}

.kds-order-timing--green {
  --timing-ink: #175b3c;
  --timing-border: #38825d;
  --timing-surface: #e5f3e9;
}

.kds-order-timing--orange {
  --timing-ink: #70400c;
  --timing-border: #c57a20;
  --timing-surface: #fff0d8;
}

.kds-order-timing--red {
  --timing-ink: #822d2b;
  --timing-border: #bd4c48;
  --timing-surface: #fbe7e4;
}

.kds-order-timing--neutral {
  --timing-ink: #465466;
  --timing-border: #8693a1;
  --timing-surface: #edf0f3;
}

.kds-order-timing__copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.kds-order-timing__label {
  color: var(--timing-ink);
  font-size: 0.82em;
  font-weight: 750;
  line-height: 1.2;
}

.kds-order-timing__description {
  color: var(--timing-ink);
  font-size: 0.72em;
  line-height: 1.35;
  opacity: 0.88;
  overflow-wrap: anywhere;
}

.kds-order-timing__readout {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 auto;
  gap: 2px;
  text-align: right;
}

.kds-order-timing__value {
  color: var(--timing-ink);
  font-family: "Outfit", "SFMono-Regular", Consolas, monospace;
  font-size: 1.65em;
  font-variant-numeric: tabular-nums;
  font-weight: 750;
  letter-spacing: -0.045em;
  line-height: 1;
  white-space: nowrap;
}

.kds-order-timing__prep {
  color: var(--timing-ink);
  font-size: 0.68em;
  line-height: 1.2;
  white-space: nowrap;
  opacity: 0.88;
}

.kds-order-timing__prep strong {
  font-weight: 750;
}

/* Timing state belongs to the whole ticket, not only the timer inset. */
.kds-order-card.kds-timing--green,
.kds-order-card.kds-timing--orange,
.kds-order-card.kds-timing--red,
.kds-pending-card.kds-timing--green,
.kds-pending-card.kds-timing--orange,
.kds-pending-card.kds-timing--red {
  border-width: 2px !important;
  border-style: solid !important;
}

.kds-order-card.kds-timing--green,
.kds-pending-card.kds-timing--green {
  background-color: #edf7ee !important;
  border-color: #39815b !important;
}

.kds-order-card.kds-timing--orange,
.kds-pending-card.kds-timing--orange {
  background-color: #fff5e6 !important;
  border-color: #c17a24 !important;
}

.kds-order-card.kds-timing--red,
.kds-pending-card.kds-timing--red {
  background-color: #fcede9 !important;
  border-color: #bd4c48 !important;
}

.dark .kds-order-card.kds-timing--green,
.dark .kds-pending-card.kds-timing--green {
  background-color: #17382b !important;
  border-color: #65b887 !important;
}

.dark .kds-order-card.kds-timing--orange,
.dark .kds-pending-card.kds-timing--orange {
  background-color: #49351e !important;
  border-color: #e2a44e !important;
}

.dark .kds-order-card.kds-timing--red,
.dark .kds-pending-card.kds-timing--red {
  background-color: #482827 !important;
  border-color: #e17c74 !important;
}

.dark .kds-order-timing--green {
  --timing-ink: #c3ebd0;
  --timing-border: #65b887;
  --timing-surface: #1b4935;
}

.dark .kds-order-timing--orange {
  --timing-ink: #ffe0ad;
  --timing-border: #e2a44e;
  --timing-surface: #533b20;
}

.dark .kds-order-timing--red {
  --timing-ink: #ffd0ca;
  --timing-border: #e17c74;
  --timing-surface: #542e2c;
}

.dark .kds-order-timing--neutral {
  --timing-ink: #d4dce5;
  --timing-border: #728092;
  --timing-surface: #293648;
}

@media (max-width: 520px) {
  .kds-order-timing {
    gap: 8px;
    padding: 9px 10px;
  }

  .kds-order-timing__value {
    font-size: 1.45em;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/OrderTiming/OrderTiming.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;EACjC,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,4DAA4D;EAC5D,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;;;;;;EAME,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".kds-order-timing {\n  --timing-ink: #344254;\n  --timing-border: #a8b2bd;\n  --timing-surface: #f1f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  border: 1px solid var(--timing-border);\n  border-left-width: 4px;\n  border-radius: 10px;\n  background: var(--timing-surface);\n  color: var(--timing-ink);\n  font: inherit;\n}\n\n.kds-order-card .kds-order-timing {\n  margin: 10px 0 6px;\n}\n\n.kds-pending-card .kds-order-timing {\n  margin-top: 12px;\n}\n\n.kds-order-card.kds-timing--green,\n.kds-order-card.kds-timing--orange,\n.kds-order-card.kds-timing--red,\n.kds-pending-card.kds-timing--green,\n.kds-pending-card.kds-timing--orange,\n.kds-pending-card.kds-timing--red {\n  background-image: none !important;\n  border-left-width: 4px !important;\n}\n\n.kds-order-timing--green {\n  --timing-ink: #175b3c;\n  --timing-border: #38825d;\n  --timing-surface: #e5f3e9;\n}\n\n.kds-order-timing--orange {\n  --timing-ink: #70400c;\n  --timing-border: #c57a20;\n  --timing-surface: #fff0d8;\n}\n\n.kds-order-timing--red {\n  --timing-ink: #822d2b;\n  --timing-border: #bd4c48;\n  --timing-surface: #fbe7e4;\n}\n\n.kds-order-timing--neutral {\n  --timing-ink: #465466;\n  --timing-border: #8693a1;\n  --timing-surface: #edf0f3;\n}\n\n.kds-order-timing__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.kds-order-timing__label {\n  color: var(--timing-ink);\n  font-size: 0.82em;\n  font-weight: 750;\n  line-height: 1.2;\n}\n\n.kds-order-timing__description {\n  color: var(--timing-ink);\n  font-size: 0.72em;\n  line-height: 1.35;\n  opacity: 0.88;\n  overflow-wrap: anywhere;\n}\n\n.kds-order-timing__readout {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex: 0 0 auto;\n  gap: 2px;\n  text-align: right;\n}\n\n.kds-order-timing__value {\n  color: var(--timing-ink);\n  font-family: \"Outfit\", \"SFMono-Regular\", Consolas, monospace;\n  font-size: 1.65em;\n  font-variant-numeric: tabular-nums;\n  font-weight: 750;\n  letter-spacing: -0.045em;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.kds-order-timing__prep {\n  color: var(--timing-ink);\n  font-size: 0.68em;\n  line-height: 1.2;\n  white-space: nowrap;\n  opacity: 0.88;\n}\n\n.kds-order-timing__prep strong {\n  font-weight: 750;\n}\n\n/* Timing state belongs to the whole ticket, not only the timer inset. */\n.kds-order-card.kds-timing--green,\n.kds-order-card.kds-timing--orange,\n.kds-order-card.kds-timing--red,\n.kds-pending-card.kds-timing--green,\n.kds-pending-card.kds-timing--orange,\n.kds-pending-card.kds-timing--red {\n  border-width: 2px !important;\n  border-style: solid !important;\n}\n\n.kds-order-card.kds-timing--green,\n.kds-pending-card.kds-timing--green {\n  background-color: #edf7ee !important;\n  border-color: #39815b !important;\n}\n\n.kds-order-card.kds-timing--orange,\n.kds-pending-card.kds-timing--orange {\n  background-color: #fff5e6 !important;\n  border-color: #c17a24 !important;\n}\n\n.kds-order-card.kds-timing--red,\n.kds-pending-card.kds-timing--red {\n  background-color: #fcede9 !important;\n  border-color: #bd4c48 !important;\n}\n\n.dark .kds-order-card.kds-timing--green,\n.dark .kds-pending-card.kds-timing--green {\n  background-color: #17382b !important;\n  border-color: #65b887 !important;\n}\n\n.dark .kds-order-card.kds-timing--orange,\n.dark .kds-pending-card.kds-timing--orange {\n  background-color: #49351e !important;\n  border-color: #e2a44e !important;\n}\n\n.dark .kds-order-card.kds-timing--red,\n.dark .kds-pending-card.kds-timing--red {\n  background-color: #482827 !important;\n  border-color: #e17c74 !important;\n}\n\n.dark .kds-order-timing--green {\n  --timing-ink: #c3ebd0;\n  --timing-border: #65b887;\n  --timing-surface: #1b4935;\n}\n\n.dark .kds-order-timing--orange {\n  --timing-ink: #ffe0ad;\n  --timing-border: #e2a44e;\n  --timing-surface: #533b20;\n}\n\n.dark .kds-order-timing--red {\n  --timing-ink: #ffd0ca;\n  --timing-border: #e17c74;\n  --timing-surface: #542e2c;\n}\n\n.dark .kds-order-timing--neutral {\n  --timing-ink: #d4dce5;\n  --timing-border: #728092;\n  --timing-surface: #293648;\n}\n\n@media (max-width: 520px) {\n  .kds-order-timing {\n    gap: 8px;\n    padding: 9px 10px;\n  }\n\n  .kds-order-timing__value {\n    font-size: 1.45em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
